import { render, staticRenderFns } from "./ReportHeavy.vue?vue&type=template&id=19b08d6e"
import script from "./ReportHeavy.vue?vue&type=script&lang=js"
export * from "./ReportHeavy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports